<template>
    <section v-if="slides.length" class="py-20 lg:py-28 bg-navy-gradient">
        <div class="container mx-auto px-4">
            <div class="relative max-w-5xl mx-auto rounded-2xl overflow-hidden min-h-[280px] md:min-h-[400px]">
                <img
                    v-if="slide.image"
                    :src="slide.image"
                    :alt="slide.title"
                    loading="lazy"
                    class="absolute inset-0 w-full h-full object-cover transition-all duration-700"
                />
                <div class="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />

                <div
                    class="relative z-10 flex flex-col justify-center h-full p-8 md:p-14 min-h-[280px] md:min-h-[400px]"
                >
                    <h3
                        class="text-2xl md:text-4xl font-bold text-primary-foreground mb-3 max-w-2xl transition-all duration-500"
                    >
                        {{ slide.title }}
                    </h3>
                    <p
                        class="text-primary-foreground/90 font-medium text-base md:text-lg max-w-xl leading-relaxed transition-all duration-500"
                    >
                        {{ slide.subtitle }}
                    </p>
                </div>

                <button
                    v-if="slides.length > 1"
                    type="button"
                    aria-label="Предыдущий слайд"
                    class="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors"
                    @click="prev"
                >
                    <BlockIcon name="ChevronLeft" class="text-primary-foreground" :size="22" />
                </button>
                <button
                    v-if="slides.length > 1"
                    type="button"
                    aria-label="Следующий слайд"
                    class="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors"
                    @click="next"
                >
                    <BlockIcon name="ChevronRight" class="text-primary-foreground" :size="22" />
                </button>

                <div v-if="slides.length > 1" class="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                    <button
                        v-for="(s, i) in slides"
                        :key="i"
                        type="button"
                        :aria-label="`Слайд ${i + 1}`"
                        class="h-2.5 rounded-full transition-all duration-300"
                        :class="i === current ? 'bg-primary-foreground w-6' : 'bg-primary-foreground/30 w-2.5'"
                        @click="goTo(i)"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";

export default {
    name: "SliderBlock",
    components: { BlockIcon },
    props: { content: { type: Object, default: () => ({}) } },
    data() {
        return { current: 0, timer: null };
    },
    computed: {
        slides() {
            return this.content.slides || [];
        },
        slide() {
            return this.slides[this.current] || {};
        },
    },
    mounted() {
        if (this.slides.length > 1) {
            this.timer = setInterval(this.next, 5000);
        }
    },
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        next() {
            this.current = (this.current + 1) % this.slides.length;
        },
        prev() {
            this.current = (this.current - 1 + this.slides.length) % this.slides.length;
        },
        goTo(i) {
            this.current = i;
        },
    },
};
</script>
